import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const MenuToggleIcon: React.FC<SVGIconProps> = ({ fill, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 10 10" {...props}>
            <g
                id="REPORT"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="03_Webreport-v3-closed"
                    transform="translate(-12.000000, -75.000000)"
                >
                    <g
                        id="Icons-/-Report"
                        transform="translate(18.000000, 80.000000) rotate(180.000000) translate(-18.000000, -80.000000) translate(6.000000, 68.000000)"
                    >
                        <rect
                            id="Rectangle-8"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                        ></rect>
                        <path
                            d="M12.3698826,13.8725054 C12.3732548,14.1512874 12.6003271,14.3783562 12.8768558,14.3794786 L16.1603685,14.3940921 C16.9247564,14.3952161 16.9236341,13.2486038 16.1592445,13.2486038 L14.7327438,13.2474797 C14.4944316,13.2474797 14.4371126,13.11146 14.6079675,12.9405965 L16.9697368,10.5788272 C17.1934358,10.3551282 17.1934358,9.99202526 16.9686128,9.76833777 C16.7449138,9.54463877 16.3818108,9.54351357 16.1581233,9.76721372 L13.7963539,12.1301053 C13.627735,12.2987242 13.490593,12.2436412 13.490593,12.0053289 L13.4894686,10.577706 C13.4883446,9.81444047 12.3417356,9.81331815 12.342858,10.576582 L12.3698826,13.8725054 Z"
                            id="Shape"
                            fill={fill ?? '#09293E'}
                            fillRule="nonzero"
                            transform="translate(14.740114, 11.997046) rotate(45.000000) translate(-14.740114, -11.997046) "
                        ></path>
                        <path
                            d="M8.91428571,8.22857143 L8.91428571,15.7714286"
                            id="Line"
                            stroke="#09293E"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export default MenuToggleIcon
